
export function isDev() {

  const hostname = window.location.hostname;

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return true;
  }

  // Production
  return false;
}

export function getJunkyardAPIHostname() {
  const hostname = window.location.hostname;

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:9000';
  }

  // Production
  return 'https://api.orangetrie.com';
}

export function getJunkyardWebsocketHostname() {
  const hostname = window.location.hostname;

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'ws://localhost:9000';
  }

  // Production
  return 'wss://api.orangetrie.com';
}
